module.exports = __webpack_public_path__ + "static/media/fox-g18d0f6665_640.72e666cf.jpg";